/**
 * Exports an event emitter, listener, and payload to signal a guide-message-producing action.
 *
 * An example of an emitter can be found in `tutor-me-button.tsx`. When the
 * button is clicked the event is emitted.
 *
 * `guide-widget.tsx` listens for the event through the
 * useGuideMessageEventHandling hook. The handler opens the chat and sends the
 * message to Khanmigo.
 */
import {createEvent, type Emitter, type Listener} from "react-event-hook";

import type {ChatInputMetadata} from "@khan/guide-types";

export interface GuideMessageProducingActionPayload {
    /**
     * `text` is the message that will be added to the conversation with Khanmigo.
     */
    text: string;
    /**
     * `requestUIType` is the source of the event (e.g. what UI element is
     * triggering a message to be sent to Khanmigo).
     */
    requestUIType: ChatInputMetadata["requestUIType"];
}

interface Event {
    useGuideMessageProducingActionListener: Listener<GuideMessageProducingActionPayload>;
    emitGuideMessageProducingAction: Emitter<GuideMessageProducingActionPayload>;
}

export const {
    useGuideMessageProducingActionListener,
    emitGuideMessageProducingAction,
} = createEvent("guide-message-producing-action")() as Event;
